import * as z from 'zod/mini';
import { Gender } from '../models/Gender.js';
import { DateISO } from '../schema/DateISO.js';
import { recordSchema } from '../schema/recordSchema.js';
import { PatientAddress } from './PatientAddress.js';
import { PatientDataType } from './PatientDataType.js';
export const PatientProfile = z.object({
    firstName: z.nullish(z.string()),
    lastName: z.nullish(z.string()),
    birthDate: z.nullish(DateISO),
    gender: z.nullish(Gender),
    address: PatientAddress,
    data: recordSchema(PatientDataType.options, z.nullish(z.string())),
});
//# sourceMappingURL=PatientProfile.js.map